import styled, { css } from 'styled-components'
import { gradientToCssOrColor } from 'utils'

type BackgroundProps = {
    isOn: boolean | undefined
    height: number
    width: number
    activeColor: string
    offColor: string
    borderRadius?: number
}

export const Container = styled.div<{ backgroundColor: string; borderRadius?: number }>`
    background: ${(props) => `${props.backgroundColor}`};
    display: inline-block;
    position: relative;
    vertical-align: top;
    page-break-inside: avoid;
    break-inside: avoid;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.01em;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    flex-shrink: 0;
    border-radius: ${(props) => props.borderRadius && `${props.borderRadius}px`};
`

export const ToggleBackground = styled.div<BackgroundProps>`
    position: absolute;
    top: 0;
    transition: all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
    ${({ isOn, activeColor, offColor }) => {
        if (isOn == undefined) {
            return ''
        } else if (isOn) {
            return css`
                background: ${gradientToCssOrColor(activeColor)};
            `
        } else {
            return css`
                background: ${gradientToCssOrColor(offColor)};
            `
        }
    }}
    height: ${(props) => `${props.height}px`};
    width: ${(props) => `${props.width / 2}px`};
    left: ${(props) => (props.isOn ? 0 : `${props.width / 2}px`)};
    border-radius: ${(props) => props.borderRadius && `${props.borderRadius}px`};
`

export const Icon = styled.div<{ isOn?: boolean; height: number; width: number; iconOn: string; iconOff: string }>`
    cursor: pointer;
    display: inline-block;
    line-height: ${(props) => props.height}px;
    position: relative;
    text-align: center;
    vertical-align: top;
    width: ${(props) => props.width / 2}px;
    height: ${(props) => props.height}px;
    transition: color 0.2s ease-in-out 0.2s;
    color: ${(props) => (props.isOn ? `${props.iconOn}` : `${props.iconOff}`)};
    i {
        font-size: 8px;
        top: -1px;
        position: relative;
    }
`

export const Text = styled.span`
    font-size: 17px;
    text-shadow: rgba(0, 0, 0, 0.2) 1px 1px 1px;
`
